import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useTranslation} from 'react-i18next'

import {mutations} from '@refra/api/mutations'
import {useRefraMutation} from '@refra/modules/common/hooks'
import {logger} from '@refra/modules/common/utils'

export const useEditDrillingSettings = () => {
  const {t} = useTranslation()

  return useRefraMutation({
    mutationFn: mutations.editDrillingSettings,
    onError: (error) => {
      const errorDetails = error?.response?.data.detail ?? error.message ?? error.response?.status
      logger
        .context('useEditDrillingSettings')
        .extras({errorDetails})
        .error('Error occurred while editing kiln shutdown')

      spawnErrorToast(t('error.editDrillingSettings'))
    },
    onSuccess: () => {
      spawnSuccessToast(t('success.editDrillingSettings'))
    }
  })
}
